import { InitialStateType } from './initialTypeTypes';

const initialState: InitialStateType = {
  loading: {},
  showSidebar: false,
  createJobsActiveTab: 'technician',
  proposalsActiveTab: 'technician',
  notifications: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },
  buildingsDetails: {},
  technicianAllProposals: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },
  technicianProposalDetails: {},
  buildings: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },

  technicianJobsDetails: {},
  technicianJobs: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },
  technicianAllJobs: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },

  printersList: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },

  acceptedProposals: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },
  printers: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },
  pricing: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },
  pricingDetails: {},

  proposalsList: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },
  proposalsListDetails: {},
  individualProposalsDetails: {},
  acceptedProposalsDetails: {},
  contracts: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },
  contractDetails: {},

  users: {},
  notificationCount: { count: 0 },
  dashboardDetails: {},

  acceptedContractJobs: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },
  pdfs: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },

  singleJobProcess: {
    review: [],
    _id: '',
  },

  jobList: {
    data: [],
    pdf: {},
  },
  PrinterClientList: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },
  symbols: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },

  templates: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },

  singleClient: {
    data: {
      fullName: '',
      emailAddress: '',
      mobileNumber: '',
      contactInfo: {
        address1: '',
        address2: '',
        city: '',
        country: '',
        postalCode: '',
      },
      shippingAddress: '',
      companyDetails: { companyName: '' },
      role: '',
    },
  },
  singleJobProcessReview: {},
  getAllPDF: {
    data: [],
  },
  cards: {},
  clientData: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },
  singleClientData: {
    _id: '',
    fullName: '',
    user: {
      emailAddress: '',
    },
    emailAddress: '',
    countryCode: '',
    mobileNumber: '',
    role: '',
    department: '',
    permissions: '',
    companyDetails: {
      companyName: '',
    },
    contactInfo: {
      address1: '',
      address2: '',
      city: '',
      country: '',
      postalCode: '',
    },
    userAddress: '',
  },

  clientJobProcess: {
    data: [],
  },
  departmentUsersData: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },
  jobAndProposal: {
    _id: '',
  },
  ProposalsJob: [],
  singleJobProcessStatus: {},
  singleTemplateData: {},

  pricingPlanTypeData: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },

  draftmanJobsData: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },
  singleDraftmanJobData: {},
  pdfUploadedPerMonth: [],
  jobsStatsPerMonth: {
    active: [],
    completed: [],
    created: [],
    inprogress: [],
  },

  technicianScheduleData: {
    data: [],
    pagination: {
      lastPage: 1,
      limit: 10,
      page: 1,
      totalData: 0,
    },
  },
};

export default initialState;
